import { t } from '@avalara/bat-apps-shared/i18n';
import type { Content } from '../../../../../types';

export const content: Array<Content> = [
  {
    title: t('client.headings.take-a-training-course'),
    textContent:
      'Avalara University has free, self-paced training courses for every step of your AvaTax journey. Sign up for live workshops led by expert instructors or watch recorded sessions later.',
    buttonText: 'Browse courses',
    link: 'https://training.avalara.com/',
  },
  {
    title: t('client.headings.find-customized-help'),
    textContent:
      'Visit the Avalara Help Center to follow along with detailed instructions for setting up AvaTax and connecting it to your business application.',
    buttonText: 'Get started',
    link: 'https://help.avalara.com/FYHP',
  },
];
